import { render, staticRenderFns } from "./BonusTypeForm.vue?vue&type=template&id=2cdf4d1e&"
import script from "./BonusTypeForm.vue?vue&type=script&lang=js&"
export * from "./BonusTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports